import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

class CustomFormatter {
    interpolate(message, values) {
        if (!values) {
            return [message]
        }

        // :nazwa podstawiamy także po nawiasie czy cudzysłowie — „(:dateEnd)”. Dłuższe klucze najpierw, a granica
        // słowa po nazwie chroni :daysWithOption przed podstawieniem :days
        let preparedString = message
        Object.entries(values)
            .sort(([a], [b]) => b.length - a.length)
            .forEach(([key, value]) => {
                const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                preparedString = preparedString.replace(new RegExp(`(^|[^\\w:]):${escapedKey}(?!\\w)`, 'g'), (_, before) => `${before}${value}`)
            })
        return new VueI18n().formatter.interpolate(preparedString, values, '')
    }
}

export const i18n = new VueI18n({
    locale: document.documentElement.lang,
    formatter: new CustomFormatter(),
    messages: {},
    silentTranslationWarn: true,
    // Interpoluj placeholdery (:email itp.) także gdy klucz nie ma jeszcze tłumaczenia
    // i renderowany jest sam klucz (lokalnie / przed SyncTranslationsJob) — patrz CustomFormatter.
    formatFallbackMessages: true,
    fallbackLocale: false,
    pluralizationRules: {
        pl(choice, choicesLength) {
            if (choice === 0) {
                return 0
            }

            if (choice === 1) {
                return 1
            }

            const teen = choice > 10 && choice < 20
            const endsWithOne = choice % 10 === 1

            if (choicesLength < 4) {
                return !teen && endsWithOne ? 1 : 2
            }
            if (!teen && endsWithOne) {
                return 3
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2
            }

            return choicesLength < 4 ? 2 : 3
        }
    }
})

const loadedLanguages = []

function setI18nLanguage(lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

async function importTranslations(lang, panel = null) {
    const panelType = panel ?? document.body.dataset.panelType

    const translations = {
        admin: {
            pl: () => import('@root/lang/admin/pl.json'),
            en: () => import('@root/lang/admin/en.json'),
            ua: () => import('@root/lang/admin/ua.json')
        },
        superpanel: {
            pl: () => import('@root/lang/superpanel/pl.json'),
            en: () => import('@root/lang/superpanel/en.json'),
            ua: () => import('@root/lang/superpanel/ua.json')
        },
        tenant: {
            pl: () => import('@root/lang/tenant/pl.json'),
            en: () => import('@root/lang/tenant/en.json'),
            ua: () => import('@root/lang/tenant/ua.json')
        },
        owner: {
            pl: () => import('@root/lang/owner/pl.json'),
            en: () => import('@root/lang/owner/en.json'),
            ua: () => import('@root/lang/owner/ua.json')
        }
    }

    if (!translations[panelType] || !translations[panelType][lang]) {
        throw new Error(`Translation not found for panel: ${panelType} and language: ${lang}`)
    }

    return translations[panelType][lang]()
}

export async function loadLanguage(lang = null, panel = null) {
    if (!lang) {
        lang = document.documentElement.lang
    }

    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    try {
        const messages = await importTranslations(lang, panel)
        i18n.setLocaleMessage(lang, messages.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
    } catch (error) {
        console.error(`Failed to load language: ${lang}`, error)
        return Promise.reject(error)
    }
}

window.$i18n = i18n
export default i18n
